module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-octagon-fill-791892e5.svg";